import type { AppVueRouter } from '@modules/core/services/router/types';
import { AppModule } from '@modules/core/plugins/AppModule';
import {
  AFFILIATE_PROFILE_SETTINGS_ROUTE_NAME,
  PROFILE_SETTINGS_PERMISSIONS,
} from '@modules/profile-settings/constants';

import {
  AFFILIATE_PROFILE_SETTINGS_PAYMENT_SYSTEMS_ROUTE_NAME,
} from './constants';

export class ProfileSettingsPaymentSystemsModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(AFFILIATE_PROFILE_SETTINGS_ROUTE_NAME, {
      name: AFFILIATE_PROFILE_SETTINGS_PAYMENT_SYSTEMS_ROUTE_NAME,
      path: 'payment-systems',
      permission: PROFILE_SETTINGS_PERMISSIONS.PAYMENT_SYSTEMS,
      component: () => import('./pages/PaymentSystemsPage/PaymentSystemsPage.vue'),
    });
  }

  addMenu(): void {
  }

  addTranslationKeys(): void {
  }
}
